import { useState } from 'react';
import { TodoTabSuggestions } from './todo-tab-suggestions';
import { Box, Button, Card, CardContent, Grid, Tab, Tabs, Typography } from '@mui/material';
import { TodoTabFixes } from './todo-tab-fixes';
import { TodoTabIssues } from './todo-tab-issues';

export const TodoTab = () => {
  const [value, setValue] = useState(0);

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
        >
            <Card>
              <CardContent>
                <Tabs
                  value={value}
                  onChange={(event, newValue) => setValue(newValue)}
                  aria-label="Acciones por hacer"
                  variant='fullWidth'
                >
                  <Tab label="Sugerencias" />
                  <Tab label="Arreglos" />
                  <Tab label="Problemas" />
                </Tabs>
                {
                  value === 0 && <TodoTabSuggestions />
                }
                {
                  value === 1 && <TodoTabFixes />
                }
                {
                  value === 2 && <TodoTabIssues />
                }
              </CardContent>
            </Card>
        </Grid>
      </Grid>
    </>
  );
}
